import { Card, Stack, Typography } from '@mui/material';
import { fontWeights } from '@/@mui/tokens/font-weights';
import { CourseTypes } from '@/packages/my-profile/components/interests-section/components/course-types';
import { KnowledgeAreas } from '@/packages/my-profile/components/interests-section/components/knowledge-areas';
import { Languages } from '@/packages/my-profile/components/interests-section/components/languages';

export const InterestsSection = () => {
  return (
    <Card>
      <Typography fontWeight={fontWeights.fontWeightSemibold} mb={2}>
        Interesses
      </Typography>
      <Stack spacing={2}>
        <CourseTypes />
        <KnowledgeAreas />
        <Languages />
      </Stack>
    </Card>
  );
};
